import { PanelResizeHandle } from "react-resizable-panels";
import DragHandleOutlinedIcon from "@mui/icons-material/DragHandleOutlined";

import styles from "./styles.module.css";

interface ResizeHandleProps {
  isVertical?: boolean;
}

export default function ResizeHandle({
  isVertical = false,
}: ResizeHandleProps) {
  return (
    <PanelResizeHandle className={styles.ResizeHandleOuter}>
      <div className={styles.ResizeHandleInner}>
        <DragHandleOutlinedIcon
          className={styles.Icon}
          style={{
            fontSize: 16,
            transform: isVertical ? "rotate(90deg) scaleX(2.5)" : "scaleX(2.5)",
          }}
        />
      </div>
    </PanelResizeHandle>
  );
}
